import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Observable } from 'rxjs'

export interface Basket {
	_id: string
	partnerId: string
	title: string
	description: string
	descriptionLong: string
	enabled: boolean
	imagePath: string
}

export interface deliveryData {
	address: string
	state: string
	city: string
	zipCode: string
	street?: string
	number: string
	neighborhood: string
	complement?: string
}

export interface CreateBasketOrderDto {
	venueId: string
	voucherId: string
	basketId: string
	clientId: string
	deliveryData: deliveryData
}

@Injectable({ providedIn: 'root' })
export class BasketService {
	private http = inject(HttpClient)
	private baseURL = `${environment.channelsAPIURL}/api`

	getAll(): Observable<Basket[]> {
		return this.http.get<Basket[]>(`${this.baseURL}/v1/baskets`)
	}

	createBasketOrder(createBasketOrder: CreateBasketOrderDto): Observable<CreateBasketOrderDto> {
		return this.http.post<CreateBasketOrderDto>(`${this.baseURL}/v1/Orders/basket`, createBasketOrder)
	}
}
